import * as secretsDev from './secretsDev.js';
import * as secretsProd from './secretsProd.js';


export default process.env.NODE_ENV
    ==='production'
        ?secretsProd
        :secretsDev;